<template>
  <div class="px-0 mx-0">
    <span class="font-weight-light caption" v-if="details.Beds">{{details.Beds}} 
      <span v-if="details.Beds > 1"> beds </span>   
      <span v-else> bed </span>   
    </span>
    <span class="font-weight-light caption">for SALE </span>
    <span class="font-weight-light caption" v-if="details.GuidePrice">&#64; {{ returnFormattedPrice(details.GuidePrice) }} </span>
    <span class="font-weight-light caption" v-if="details.AvailableFrom">available from {{ returnDate(details.AvailableFrom) }}</span>

    <!-- <p class="my-0 font-weight-medium">For sale</p>
    <p v-if="details.Beds" class="my-0">Beds: {{details.Beds}}</p>
    <p v-if="details.GuidePrice" class="my-0">Price: {{ returnFormattedPrice(details.GuidePrice) }}</p>
    <p v-if="details.AvailableFrom" class="my-0">Available from: {{ returnDate(details.AvailableFrom) }}</p> -->

  </div>
</template>

<script>
import moment from 'moment/src/moment'
export default {
  props: ['property'],
  data() {
    return {
      details: ''
    }
  },
  methods: {
    returnDate(date) {
      return moment(date).format("DD/MM/YYYY")
    },
    returnFormattedPrice(price) {
      let newValue = parseFloat(price).toLocaleString('en-GB')
      return '£' + newValue
    }
  },
  created() {
    this.$store.dispatch('salesInstructionsDetails', this.property.OID)
      .then( ({data}) => {
        this.details = data
      })
    } 
  }
</script>

